import EnumType from "../shared/EnumType";

const values = {
  Active: 0,
  Plugged: 1,
  Cemented: 2
};

export default EnumType.generate(values, "Drilling.CementationType.");